'use client';

// EKA-008 (2026-04-08): Forgot password — Supabase resetPasswordForEmail
import { useState } from 'react';
import Link from 'next/link';
import { Mail, Loader2, CheckCircle2 } from 'lucide-react';
import Button from '@/components/ui/button';
import Input from '@/components/ui/input';
import { createClient } from '@/lib/supabase/client';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const supabase = createClient();
      const origin = typeof window !== 'undefined' ? window.location.origin : '';
      const { error: err } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${origin}/auth/reset-password`,
      });
      if (err) throw err;
      setSent(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Nie udało się wysłać maila.');
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="space-y-4 text-center">
        <CheckCircle2 className="mx-auto h-12 w-12 text-emerald-400" />
        <h2 className="text-2xl font-bold text-slate-900">Sprawdź skrzynkę</h2>
        <p className="text-sm text-slate-500">
          Wysłaliśmy link do resetowania hasła na <strong>{email}</strong>. Sprawdź skrzynkę i
          kliknij link.
        </p>
        <Link
          href="/login"
          className="inline-block text-sm text-[#239D9F] hover:text-[#11305A]"
        >
          Wróć do logowania
        </Link>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-5">
      <div>
        <h2 className="text-2xl font-bold text-slate-900">Odzyskaj hasło</h2>
        <p className="mt-1 text-sm text-slate-500">
          Wpisz adres email — wyślemy Ci link do resetowania.
        </p>
      </div>

      {error && <div className="rounded-lg bg-red-50 p-3 text-sm text-red-700">{error}</div>}

      <div className="space-y-2">
        <label className="block text-sm font-medium text-slate-700">Email</label>
        <div className="relative">
          <Mail className="absolute left-3 top-3 h-5 w-5 text-slate-400" />
          <Input
            type="email"
            placeholder="twoj@kancelaria.pl"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="pl-10"
            required
            disabled={loading}
          />
        </div>
      </div>

      <Button type="submit" disabled={loading} className="w-full">
        {loading ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : null}
        Wyślij link resetujący
      </Button>

      <p className="text-center text-sm text-slate-500">
        <Link href="/login" className="text-[#239D9F] hover:text-[#11305A]">
          Wróć do logowania
        </Link>
      </p>
    </form>
  );
}
